import {Grid} from '@mui/material'

type LayoutProps = {
  stoppageAnalysisGraphSlot: React.ReactNode
  stoppageAnalysisListSlot: React.ReactNode
  stoppageAnalysisSideCardSlot: React.ReactNode
  stoppageCreateFormSlot: React.ReactNode
  showStoppageAnalysisSideCard: boolean
  showCreateForm: boolean
  isMobile?: boolean
}

export const StoppageAnalysisLayout: React.FC<LayoutProps> = ({isMobile, ...layoutProps}) => {
  return isMobile ? <MobileLayout {...layoutProps} /> : <DesktopLayout {...layoutProps} />
}

const DesktopLayout = ({
  stoppageAnalysisGraphSlot,
  stoppageAnalysisListSlot,
  stoppageAnalysisSideCardSlot,
  stoppageCreateFormSlot,
  showStoppageAnalysisSideCard,
  showCreateForm
}: LayoutProps) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {stoppageAnalysisGraphSlot}
      </Grid>
      <Grid item xs={12} sm={8}>
        {stoppageAnalysisListSlot}
      </Grid>
      {showStoppageAnalysisSideCard && (
        <Grid item xs={12} sm={4}>
          {stoppageAnalysisSideCardSlot}
        </Grid>
      )}
      {showCreateForm && !showStoppageAnalysisSideCard && (
        <Grid item xs={12} sm={4}>
          {stoppageCreateFormSlot}
        </Grid>
      )}
    </Grid>
  )
}

const MobileLayout = ({
  stoppageAnalysisGraphSlot,
  stoppageAnalysisListSlot,
  stoppageAnalysisSideCardSlot,
  stoppageCreateFormSlot,
  showStoppageAnalysisSideCard,
  showCreateForm
}: LayoutProps) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {stoppageAnalysisGraphSlot}
      </Grid>
      <Grid item xs={12}>
        {showStoppageAnalysisSideCard
          ? stoppageAnalysisSideCardSlot
          : showCreateForm
            ? stoppageCreateFormSlot
            : stoppageAnalysisListSlot}
      </Grid>
    </Grid>
  )
}
